<template>
  <div class="filters">
    <!-- <button v-if="mobileMode" class="filter__close-btn btn-close" @click="closeFilters"><i class="el-icon-close"></i></button> -->
    <el-input
      class="input-fio"
      placeholder="ФИО студента"
      v-model="form.student_name"
      size="small"
    ></el-input>
    <el-select
      class="select-group"
      v-model="form.group_id"
      placeholder="Выберите группу"
      size="small"
      @change="form.group.change = true"
    >
      <el-option
        v-for="(item, index) in cacheGroupList"
        :key="index"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-select
      class="select-type-work"
      v-model="form.work_id"
      placeholder="Тип работы"
      size="small"
    >
      <el-option
        v-for="(item, index) in cacheTypeWork"
        :key="index"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-select
      class="select-status"
      v-model="form.checked"
      placeholder="Статус"
      size="small"
    >
      <el-option
        v-for="(item, index) in supporting.checkWork"
        :key="index"
        :label="item.name"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      class="select-done"
      v-model="form.done"
      placeholder="Выполнена"
      size="small"
      @change="form.workCompleted.change = true"
    >
      <el-option
        v-for="(item, index) in supporting.doneWork"
        :key="index"
        :label="item.name"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <span class="lable-for-send">Дата отправки</span>
    <el-date-picker
      class="date-picker-send"
      @change="changeDateSend"
      v-model="sent_time"
      size="small"
      type="daterange"
      range-separator="До"
      unlink-panels
      start-placeholder="Начальная дата"
      format="dd.MM.yyyy"
      value-format="dd.MM.yyyy"
      end-placeholder="Конечная дата"
    >
    </el-date-picker>
    <span class="lable-for-check">Дата проверки</span>
    <el-date-picker
      class="date-picker-check"
      @change="changeDateDone"
      v-model="done_time"
      size="small"
      type="daterange"
      unlink-panels
      format="dd.MM.yyyy"
      value-format="dd.MM.yyyy"
      range-separator="До"
      start-placeholder="Начальная дата"
      end-placeholder="Конечная дата"
    >
    </el-date-picker>
    <el-button class="button-run" @click="filterRun" type="primary" size="small"
      >Отфильтровать</el-button
    >
    <el-button class="button-cancel" @click="setDefaultFilter" size="small"
      >Очистить</el-button
    >
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      form: {
        student_name: "",
        group_id: "",
        work_id: "",
        checked: 0,
        done: "",
        sent_start_time: "",
        sent_end_time: "",
        verified_start_time: "",
        verified_end_time: "",
      },
      done_time: "",
      sent_time: "",
      supporting: {
        checkWork: [
          { value: null, name: "" },
          { value: 1, name: "Проверено" },
          { value: 0, name: "Не проверено" },
        ],
        doneWork: [
          { value: null, name: "" },
          { value: 1, name: "Выполнена" },
          { value: 0, name: "Не выполнена" },
        ],
        groupList: [],
        typeWork: [],
        teacherList: [],
      },
    };
  },
  props: {
    mobileMode: Boolean,
    groupList: Array,
    typeWork: Array,
    filters: Object,
    fetchCb: Function,
  },
  computed: {
    cacheGroupList() {
      return [{ id: null, name: "" }, ...this.groupList];
    },
    cacheTypeWork() {
      return [{ id: null, name: "" }, ...this.typeWork];
    },
  },

  methods: {
    ...mapMutations(["setActiveFilters", "setActiveFilters"]),
    preparationForm() {
      let form = {};
      for (let key in this.form) {
        if (this.form[key] !== "") form[key] = this.form[key];
      }
      return form;
    },
    filterRun() {
      let form = this.preparationForm();
      this.fetchCb(`api/results/${this.$route.params.did}/wresults`, form);
    },
    closeFilters() {
      this.$parent.showFilters = false;
    },
    changeDateSend(value) {
      this.form.sent_start_time = value[0];
      this.form.sent_end_time = value[1];
    },
    changeDateDone(value) {
      this.form.verified_start_time = value[0];
      this.form.verified_end_time = value[1];
    },
    setDefaultFilter() {
      for (let key in this.form) {
        this.form[key] = "";
      }
      this.done_time = "";
      this.sent_time = "";
      this.fetchCb(`api/results/${this.$route.params.did}/wresults`);
    },
  },
  mounted() {
    //this.setDefaultFilter();
  },
};
</script>

<style lang="scss">
.filters {
  transform: translateX(0);
  opacity: 1;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    "fio group type  run"
    "leble-send leble-check done  cancel"
    "send  check status .";
  justify-items: center;
  align-items: center;
  transition-property: transform opacity;
  transition-duration: 0.3s;
  background-color: $basic-white;
  column-gap: 10px;
  row-gap: 10px;
  padding: 20px;
  height: max-content;
  z-index: 21;
  max-width: 1090px;
  .el-range-separator {
    margin: 0 10px !important;
  }
  .el-switch {
    justify-self: start;
  }
  .el-button {
    width: 70%;
    margin: 0 auto !important;
  }
  .date-picker-send {
    grid-area: send;
  }
  .date-picker-check {
    grid-area: check;
  }
  .input-fio {
    grid-area: fio;
  }
  .select-group {
    width: 100%;
    grid-area: group;
  }
  .select-type-work {
    grid-area: type;
  }
  .select-status {
    grid-area: status;
  }
  .select-done {
    grid-area: done;
  }
  .button-run {
    grid-area: run;
  }
  .button-cancel {
    grid-area: cancel;
  }
  .lable-for-send {
    color: $regular-text-clr;
    grid-area: leble-send;
  }
  .lable-for-check {
    color: $regular-text-clr;
    grid-area: leble-check;
  }
}
@media (max-width: 800px) {
  .filters {
    row-gap: 15px;
    height: 100%;
    width: 100%;
    padding: 0;
    padding-top: 30px;
    position: absolute;
    left: 0;
    top: 0;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(9, min-content);
    grid-template-areas:
      "fio"
      "group"
      "type"
      "done"
      "send"
      "check"
      "status"
      "cancel"
      "run";
    .lable-for-check,
    .lable-for-send {
      display: none;
    }
    .el-date-editor--daterange.el-input__inner {
      width: 280px;
    }
    .filter__close-btn {
      display: none;
    }
  }
}
</style>
